import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

export const useSettingsTeamInviteForm = defineStore('settingsTeamInviteForm', () => formModule({
  fields: {
    email: { rules: [{ name: 'required' }] },
  },
}));
